<div class="wrapper">
  <mat-drawer-container>
    <mat-drawer #drawer mode="side" [ngClass]="{'menu-open': show, 'menu-closed': !show}" [opened]="true">
      <div class="top-nav">
        @if (show) {
          <h2>{{header}}</h2>
        }
        <button matIconButton (click)="toggle()" style="margin-left: auto">
          @if (show) {
            <mat-icon>close</mat-icon>
          }
          @if (!show) {
            <mat-icon>menu</mat-icon>
          }
        </button>
      </div>
      <mat-nav-list>
        @for (link of links; track link.uuid + '-' + $index) {
          @if (!link.func) {
            <a mat-list-item [routerLinkActive]="['active']" class="center-flex" [ngClass]="{ 'center': !show }" [routerLink]="link.path"
              [matTooltip]="!show ? link.label: ''" [matTooltipPosition]="'right'" [matTooltipShowDelay]="500"
              routerLinkActive #rla="routerLinkActive">
              <div class="center-flex">
                @if (link.icon) {
                  <mat-icon class="material-icons-outlined" [ngClass]="{'icon': !show}">
                    {{link.icon}}
                  </mat-icon>
                }
                @if (show) {
                  <span class="label">{{link.label}}</span>
                }
              </div>
            </a>
          }

          @if (link.func) {
            <a mat-list-item [ngClass]="{ 'center': !show }" (click)="link.func()"
              [matTooltip]="!show ? link.label: ''" [matTooltipPosition]="'right'" [matTooltipShowDelay]="500">
              <div class="center-flex">
                @if (link.icon && link.func) {
                  <mat-icon class="material-icons-outlined" [ngClass]="{'icon': !show}">
                    {{link.icon}}
                  </mat-icon>
                }
                @if (link.func && show) {
                  <span matLine class="label">{{link.label}}</span>
                }
              </div>
            </a>
          }
        }
      </mat-nav-list>
    </mat-drawer>
    <mat-drawer-content [ngStyle]="{ 'margin-left.px': contentMargin}">
      <router-outlet></router-outlet>
    </mat-drawer-content>
  </mat-drawer-container>
</div>